import { machines } from '../machines/machines-sidecar'
import { advanceTask } from './advanceTask'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, registerJob } from './jobs'
import { createTask_moveTo } from './taskMoveTo'

export const register = () => registerJob('idle', runJob)

export function runJob(job: IJob) {
  jobLogger.assertJobType(job, 'idle')

  // Seed job tasks
  if (job.tasks.length === 0) {
    let m = jobLogger.assertReserved(job)
    let mc = machines.findClosestTo(m.i, m.j, (c) => c.data.type === 'table')
    if (mc) {
      let task = createTask_moveTo(mc.i, mc.j, true, false)
      job.tasks.push(task)
    }
    return
  }

  advanceTask(job)
}
